module.exports = __webpack_public_path__ + "img/index.4fb1b628.jpg";